import React from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { SectionHeader } from "../components/section-header.tsx";
import { FontStyles } from "../utils/font-styles.ts";
import { ButtonLink } from "../components/buttons/button-link.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import { TrackEvent } from "../utils/analytics.ts";
import { useReportClick } from "./hooks/use-report-click.ts";

const buttonContainer = "flex flex-col md:flex-row gap-3 md:gap-4 self-stretch w-full";
export const MoreInformation: React.FC = (): React.ReactElement | null => {
  const { hrLink, scheduleLink, digitalBrochureLink } = usePropertyDetailsContext();
  const reportClick = useReportClick();
  if (!hrLink && !scheduleLink && !digitalBrochureLink) return null;
  let buttonStyle = "flex w-full flex-col";
  if ([digitalBrochureLink, hrLink, scheduleLink].filter(Boolean).length === 1) {
    buttonStyle += " md:w-1/2";
  }
  const reportBrochureClick = () => {
    TrackEvent({ name: "brochure_clicked", value: 5 });
    reportClick("/reporting/digital-brochure-clicked");
  };
  return (
    <div className={"flex flex-col gap-3 md:gap-3.5"}>
      <SectionHeader text={`More information`} as={"h2"} className={FontStyles.h5} />
      <div className={buttonContainer}>
        {hrLink && (
          <div className={buttonStyle}>
            <ButtonLink
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-file-lines" />}
              colorVariant={"secondary"}
              variant={"solid"}
              label={"Get home report"}
              href={hrLink}
            />
          </div>
        )}
        {scheduleLink && (
          <div className={buttonStyle}>
            <ButtonLink
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-book-open" />}
              colorVariant={"secondary"}
              variant={"outlined"}
              target="_blank"
              label={"View schedule"}
              href={scheduleLink}
              rel={"noopener noreferrer"}
              onClick={() => TrackEvent({ name: "schedule_clicked", value: 15 })}
            />
          </div>
        )}
        {digitalBrochureLink && (
          <div className={buttonStyle}>
            <ButtonLink
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-arrow-up-right-from-square" />}
              colorVariant={"secondary"}
              target="_blank"
              variant={"outlined"}
              label={"View brochure"}
              href={digitalBrochureLink}
              onClick={reportBrochureClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};
